import React, { useState, useEffect } from "react"

import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import SweetAlert from "react-bootstrap-sweetalert"
import { CheckPermission } from "../Permissions/CheckPermissions";
import moment from "moment"
import { CircularProgress } from "@material-ui/core";
import { FaPen , FaRegTrashAlt, FaPlus} from "react-icons/fa";


const MarketingBanners = (props) => {

  const sortOptions = [
    { id: 1, value: "enabled", label: "Enabled" },
    { id: 2, value: "all", label: "All" }
  ]

  const [data, setData] = useState([])
  const [sortBy, setSortBy] = useState(sortOptions[0].value)
  const [token, setToken] = useState('')
  const [success_msg, setsuccess_msg] = useState(false)
  const [errorMessage, SetErrorMessage] = useState('')
  const [errorMsgAlert, setErrorMsgAlert] = useState(false)
  const [del, setDelete] = useState(false)
  const [ItemForDelete, setItemForDelete] = useState('initialState')
  const [pages, setPages] = useState([])
  const [loading,setloading]=useState(true)


  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken")
    setToken(token)
    getMiniBanners(token)
  }, [sortBy, success_msg])

  useEffect(() => {
    // autoDisableBanners(data, token)

    return (() => { })
  }, [setData, token, errorMessage])


  const handleConfirmation = () => {

    return (

      <SweetAlert
        title="Warning"
        warning
        showCancel={true}
        showConfirm={true}
        btnSize="lg"
        confirmBtnText="Delete"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="secondary"
        onConfirm={() => {
          deleteEntry(ItemForDelete?.item_id, token)
          setDelete(false)
          // props?.history.push(`/carousel-banners/estore`)
          // setsuccess_msg(false)
        }}
        onCancel={() => setDelete(false)}
        show={true}>
        {"Are you sure you want to delete ?"}
      </SweetAlert>
    )
  };

  const autoDisableBanners = (data, token) => {
    data?.map((item) => {
      const timestamp = new Date(item.unpublished_at)
      const currentDate = new Date()
      if (timestamp < currentDate) {
        if (item?.item_status == "Y" && item?.unpublished_at !== "null") {
          changeDate(item, token)
        }
      }
    })
  }
  //
  function changeDate(item, token) {

    var myHeaders = new Headers();

    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");


    var formdata = new FormData();
    formdata.append("path", "carousel/update");
    formdata.append("env", "staging");
    formdata.append("created_datetime", item?.created_datetime);
    formdata.append("item_id", item?.item_id);
    formdata.append("item_status", "N");
    formdata.append("item_type", "\"carousel_banner\"");
    formdata.append("item_version", item?.item_version);
    formdata.append("navigate_to", item?.navigate_to);
    formdata.append("page", item?.page);
    formdata.append("published_at", item?.published_at);
    formdata.append("unpublished_at", item?.unpublished_at);
    formdata.append("slider_delay", "3");
    formdata.append("sort_order", item?.sort_order);
    formdata.append("api", "true");
    formdata.append("updated_datetime", moment(new Date()).format("YYYY/MM/DD HH:mm"));

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then(response => {
        if (response.status == 200) {
          setSortBy("enabled")
          SetErrorMessage("Hi")
        } else {
        }
        response.json()
      })
      .then(result => { })
      .catch(error => console.log('error', error));

  }

  const getMiniBanners = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=banners&env=production`, requestOptions)
      .then(response => response.json())
      .then(result => {
        setloading(false)
        let tempData = []
        if (result) {
          result?.banners?.map((item) => {
            if (item.banner_type == "mini_banner") {
              tempData = [...tempData, item]
            }
          })
          /*Sorting according to postion and date */
          tempData?.sort((a, b) => {
              return (Date.parse(b.published_at) - Date.parse(a.published_at))
          })
          // autoDisableBanners(tempData, token)
          console.log("Checking fields for mini banners", tempData)
          setData(tempData)
        }
      })
      .catch(error => console.log('error', error));
  }
  const deleteEntry = (ID, token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=banners/delete&id=${ID}`, requestOptions)
      .then(response => {
        if (response.status == 200) {
          setsuccess_msg(true)
        } else {
          setErrorMsgAlert(true)
        }
        response.text()
      })
      .then(result => console.log(result))
      .catch(error => console.log('error', error));

  }
  const handleLabel=(item)=>{
    if(item === "Campaign_blog"){
      item= "Blog";
      return item
    }else if(item==="PaymentBanner"){
        item="FRx Transactions"
        return item
    }
    else if(item ==="Campaign_CarparkMainPage"){
      item="Carpark$"
      return item
    }
    else if(item === "Campaign_deals"){
      item = "Deals";
      return item
    }else if(item === "Campaign_promotions"){
      item = "Promotions";
      return item
    }else if(item === "Campaign_event"){
      item = "Events";
      return item
    }else if(item === "Campaign_buyforfriend"){
      item= "DGC Buy Friend Art";
      return item
    }else if(item === "Campaign_cardart"){
      item = "DGC Buy Friend Art";
      return item
    }
    else if(item === "Campaign_orderreview"){
      item = "DGC Buy Friend Checkout";
      return item
    }
    else if(item === "Campaign_dgcMain"){
      item = "DGC Main";
      return item
    }
    else if(item === "Campaign_buyformyself"){
      item = "DGC Buy Myself Checkout";
      return item
    }
    else if(item === "MM_mini_Banner"){
      item = "Makan Master";
      return item
    }
    else if(item === "campaign_dgc_mini"){
      item = "DGC Buy Myself Amount";
      return item
    } else if(item === "campaign_dgc_mini_ff"){
      item = "DGC Buy Friend Amount";
      return item
    }
    else if(item==="Campaign_ewallet"){
      item = "e-wallet";
      return item
    }
    else{
      return item
    }
  }
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          setsuccess_msg(false)
          // props.props?.history.push("/campaigns")
        }}
        onCancel={() => {
          setsuccess_msg(false)
        }}
      >
        {"Mini banner deleted successfully."}
      </SweetAlert>
    )
  }
  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    )
  }
  //
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Marketing Banners" breadcrumbItem="Mini Banners" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <CardTitle className="h4">
                    <Row>
                      <Col lg={6} md={12} sm={12}>
                        <Button
                         disabled={!CheckPermission("banners","add")}
                          className="btn btn-success waves-effect waves-light"
                          onClick={() => {
                            props?.history?.push("/marketing-banners/add-mini-banner")
                          }}
                        >
                          <FaPlus size={12} />{" "}
                          Add Mini Banner
                        </Button>
                      </Col>
                      <Col lg={6} md={12} sm={12}
                        style={{ textAlign: "right" }}>
                        <div className="mb-3">
                          {/* <Label>Discount Type</Label> */}
                          <label htmlFor="cars">Status</label>

                          <select name="cars" defaultValue={sortOptions[0].value} id="cars" onChange={(e) => { setSortBy(e.target.value) }}
                            style={{ width: 80, height: 30, marginLeft: 10 }}>
                            {sortOptions?.map((item, index) => {
                              return (
                                <option key={index} value={item.value}>{item.label}</option>
                              )
                            })}
                          </select>
                        </div>
                      </Col>
                    </Row>
                  </CardTitle>
                  {/*// */}
                  {loading ? <div role="status" style={{ textAlign: "center" }}>
                        <CircularProgress
                         size={50} value={100} color={"black"}
                        />
                      </div> : <div className="table-responsive">
                    <table className="table table-bordered border-primary mb-0">

                      <thead>
                        <tr>
                          <th>Image</th>
                          <th>Name</th>
                          <th>Publish At</th>
                          <th>Unpublish At</th>
                          <th>Status</th>
                          <th>Action</th>
                          <th>Version</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((item, index) => {
                          if (sortBy == "enabled") {
                            if (item?.item_status !== "Y") {
                              return
                            }
                          }
                          return (

                            <tr key={index}>
                              <th scope="row">
                                <img
                                  src={item?.image_url}
                                  style={{ width: 250 }}
                                  alt=""
                                />
                              </th>
                              <td>{handleLabel(item?.page)}</td>
                              {/*<td>{item?.navigate_to}</td>*/}
                              <td>{moment(item?.published_at).format("DD/MM/YYYY h:mm a")}</td>
                              <td>{item?.unpublished_at == "null" ? "Never-Ending" : moment(item?.unpublished_at).format("DD/MM/YYYY h:mm a")}</td>
                              <td>
                                {item?.item_status == "Y" ?
                                  <Button color="success" className="btn-soft-success waves-effect waves-light">Enabled</Button>
                                  :
                                  <Button color="danger" className="btn-soft-danger waves-effect waves-light">Disabled</Button>
                                }
                              </td>
                              {/*// */}
                              <td>
                                <Row className="">
                                  <div className="d-flex justify-content-center">
                                    {CheckPermission("banners","update")&&<div style={{ width: 30 }} className=" text-primary">
                                      <a className="font-size-18"
                                        onClick={() => {
                                          props?.history?.push("/marketing-banners/add-mini-banner", { edit: true, item: item })
                                        }}
                                      ><FaPen /></a></div>}
                                    {success_msg ? (
                                      renderSuccessAlert()
                                    )
                                      :
                                      null
                                    }
                                    {errorMsgAlert ? (
                                      renderFailureAlert()
                                    )
                                      :
                                      null
                                    }
                                    {/* deleteEntry(item?.item_id, token)} */}
                                    {CheckPermission("banners","delete")&&<div style={{ width: 30, textAlign: "center" }} >
                                      <Link to="#" className="px-3 text-danger" >
                                        <i className="font-size-18 " onClick={() => {
                                          setItemForDelete(item)
                                          setDelete(true)
                                        }}><FaRegTrashAlt /></i>
                                      </Link>
                                    </div>}
                                  </div>
                                </Row>
                              </td>
                              <td>{item?.item_version}</td>
                            </tr>
                          )
                        })

                        }
                      </tbody>
                    </table>
                  </div>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        {del ? handleConfirmation() : null}

      </div>
    </React.Fragment>
  )
}

export default MarketingBanners
